export enum ProjectActionType {
	ADD_PROJECT_DETAILS = 'ADD_PROJECT_DETAILS',

	FETCH_QUOTATION_LIST = 'FETCH_QUOTATION_LIST',
	STORE_QUOTATION_LIST = 'STORE_QUOTATION_LIST',
	SEND_CUSTOMER_OTP = 'SEND_CUSTOMER_OTP',
	SEND_CUSTOMER_OTP_FAILED = 'SEND_CUSTOMER_OTP_FAILED',
	SEND_CUSTOMER_OTP_SUCCESS = 'SEND_CUSTOMER_OTP_SUCCESS',

	RESEND_CUSTOMER_OTP = 'RESEND_CUSTOMER_OTP',

	UPLOAD_FLOOR_PLAN = 'UPLOAD_FLOOR_PLAN',

	GET_PREDICTION_ID = 'GET_PREDICTION_ID',
	GET_PREDICTION = 'GET_PREDICTION',
	STORE_AREAS = 'STORE_AREAS',
	PREDICTION_FAILED = 'PREDICTION_FAILED',

	GET_PRE_DESIGN_QUOTATION = 'GET_PRE_DESIGN_QUOTATION',
	STORE_PRE_DESIGN_QUOTATION = 'STORE_PRE_DESIGN_QUOTATION',
	ERROR_PRE_DESIGN_QUOTATION = 'ERROR_PRE_DESIGN_QUOTATION',

	GET_DEFAULT_QUOTATION = 'GET_DEFAULT_QUOTATION',
	STORE_DEFAULT_QUOTATION = 'STORE_DEFAULT_QUOTATION',
	ERROR_DEFAULT_QUOTATION = 'ERROR_DEFAULT_QUOTATION',
	FETCH_PRE_DESIGN_SAVED_STATE = 'FETCH_PRE_DESIGN_SAVED_STATE',
	SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS',
	RESET_NEW_PROJECT_FLOW = 'RESET_NEW_PROJECT_FLOW',

	VERIFY_CUSTOMER_OTP = 'VERIFY_CUSTOMER_OTP',
	VERIFY_CUSTOMER_OTP_FAILED = 'VERIFY_CUSTOMER_OTP_FAILED',

	SET_LEAD_NAME = 'SET_LEAD_NAME',
	STORE_PREDICTION_ID = 'STORE_PREDICTION_ID',

	CREATE_QUOTATION = 'CREATE_QUOTATION',
	CREATE_QUOTATION_LOADING = 'CREATE_QUOTATION_LOADING',

	FETCH_PROJECT_DETAILS = 'FETCH_PROJECT_DETAILS',
	ERROR_FETCH_PROJECTS_DETAILS = 'ERROR_FETCH_PROJECTS_DETAILS',
	STORE_PROJECT_DETAILS = 'STORE_PROJECT_DETAILS',

	FETCH_PROJECT_ACTIVITIES = 'FETCH_PROJECT_ACTIVITIES',
	STORE_PROJECT_ACTIVITIES = 'STORE_PROJECT_ACTIVITIES',
	ERROR_PROJECT_ACTIVITIES = 'ERROR_PROJECT_ACTIVITIES',

	COMPLETE_PROJECT_ACTIVITY = 'COMPLETE_PROJECT_ACTIVITY',
	UPLOAD_ACTIVITY_DOCUMENT = 'UPLOAD_ACTIVITY_DOCUMENT',

	UPLOAD_MORE_ACTIVITY_DOCUMENT = 'UPLOAD_MORE_ACTIVITY_DOCUMENT',

	FETCH_ACTIVITY_DOCUMENTS = 'FETCH_ACTIVITY_DOCUMENTS',
	ERROR_FETCH_ACTIVITY_DOCUMENTS = 'ERROR_FETCH_ACTIVITY_DOCUMENTS',
	STORE_ACTIVITY_DOCUMENTS = 'STORE_ACTIVITY_DOCUMENTS',
	RESET_ACTIVITY_DOCUMENTS = 'RESET_ACTIVITY_DOCUMENTS',

	FETCH_CURRENT_ACTIVITY = 'FETCH_CURRENT_ACTIVITY',
	STORE_CURRENT_ACTIVITY = 'STORE_CURRENT_ACTIVITY',

	UPLOAD_PROJECT_DETAILS = 'UPLOAD_PROJECT_DETAILS',

	FETCH_ALL_PROJECTS = 'FETCH_ALL_PROJECTS',
	STORE_ALL_PROJECTS = 'STORE_ALL_PROJECTS',
	ERROR_FETCH_ALL_PROJECTS = 'ERROR_FETCH_ALL_PROJECTS',

	FETCH_PROJECT_PRODUCT_CATEGORIES = 'FETCH_PROJECT_PRODUCT_CATEGORIES',
	STORE_PROJECT_PRODUCT_CATEGORIES = 'STORE_PROJECT_PRODUCT_CATEGORIES',
	ERROR_PROJECT_PRODUCT_CATEGORIES = 'ERROR_PROJECT_PRODUCT_CATEGORIES',

	FETCH_2D_JSON = 'FETCH_2D_JSON',
	ERROR_FETCH_2D_JSON = 'ERROR_FETCH_2D_JSON',
	STORE_2D_JSON = 'STORE_2D_JSON',

	FETCH_3D_JSON = 'FETCH_3D_JSON',
	ERROR_FETCH_3D_JSON = 'ERROR_FETCH_3D_JSON',
	STORE_3D_JSON = 'STORE_3D_JSON',

	FETCH_WARRANTY_DETAILS = 'FETCH_WARRANTY_DETAILS',
	STORE_WARRANTY_DETAILS = 'STORE_WARRANTY_DETAILS',
	ERROR_WARRANTY_DETAILS = 'ERROR_WARRANTY_DETAILS',

	FETCH_LEAD_PROJECTS = 'FETCH_LEAD_PROJECTS',
	STORE_LEAD_PROJECTS = 'STORE_LEAD_PROJECTS',

	FETCH_QUOTATION_AREA_LIST_DROPDOWN = 'FETCH_QUOTATION_AREA_LIST_DROPDOWN',
	STORE_QUOTATION_AREA_LIST_DROPDOWN = 'STORE_QUOTATION_AREA_LIST_DROPDOWN',
	ERROR_QUOTATION_AREA_LIST_DROPDOWN = 'ERROR_QUOTATION_AREA_LIST_DROPDOWN',

	FETCH_SAVED_QUOTATION = 'FETCH_SAVED_QUOTATION',
	ERROR_SAVED_QUOTATION = 'ERROR_SAVED_QUOTATION',

	FETCH_PAYMENT_SLIPS = 'FETCH_PAYMENT_SLIPS',
	STORE_PAYMENT_SLIPS = 'STORE_PAYMENT_SLIPS',
	ERROR_PAYMENT_SLIPS = 'ERROR_PAYMENT_SLIPS',

	FETCH_LEDGER_DATA = 'FETCH_LEDGER_DATA',
	STORE_LEDGER_DATA = 'STORE_LEDGER_DATA',
	ERROR_LEDGER_DATA = 'ERROR_LEDGER_DATA',

	FETCH_ALL_PAYMENTS = 'FETCH_ALL_PAYMENTS',
	STORE_ALL_PAYMENTS = 'STORE_ALL_PAYMENTS',
	ERROR_ALL_PAYMENTS = 'ERROR_ALL_PAYMENTS',

	FETCH_CUSTOMER_SLIPS = 'FETCH_CUSTOMER_SLIPS',
	STORE_CUSTOMER_SLIPS = 'STORE_CUSTOMER_SLIPS',
	ERROR_CUSTOMER_SLIPS = 'ERROR_CUSTOMER_SLIPS',
	// Warranty Claim Actions
	CHECK_WARRANTY_VALIDITY = 'CHECK_WARRANTY_VALIDITY',
	STORE_WARRANTY_VALIDITY = 'STORE_WARRANTY_VALIDITY',
	ERROR_CHECK_WARRANTY_VALIDITY = 'ERROR_CHECK_WARRANTY_VALIDITY',

	CREATE_WARRANTY_CLAIM = 'CREATE_WARRANTY_CLAIM',
	STORE_WARRANTY_CLAIM = 'STORE_WARRANTY_CLAIM',
	ERROR_CREATE_WARRANTY_CLAIM = 'ERROR_CREATE_WARRANTY_CLAIM',

	GET_WARRANTY_CLAIM = 'GET_WARRANTY_CLAIM',
	STORE_WARRANTY_CLAIM_DETAILS = 'STORE_WARRANTY_CLAIM_DETAILS',
	ERROR_GET_WARRANTY_CLAIM = 'ERROR_GET_WARRANTY_CLAIM',

	GET_ALL_WARRANTY_CLAIMS = 'GET_ALL_WARRANTY_CLAIMS',
	STORE_ALL_WARRANTY_CLAIMS = 'STORE_ALL_WARRANTY_CLAIMS',
	ERROR_GET_ALL_WARRANTY_CLAIMS = 'ERROR_GET_ALL_WARRANTY_CLAIMS',

	GET_WARRANTY_CLAIMS_BY_LEAD = 'GET_WARRANTY_CLAIMS_BY_LEAD',
	STORE_WARRANTY_CLAIMS_BY_LEAD = 'STORE_WARRANTY_CLAIMS_BY_LEAD',
	ERROR_GET_WARRANTY_CLAIMS_BY_LEAD = 'ERROR_GET_WARRANTY_CLAIMS_BY_LEAD',

	FETCH_ALL_WARRANTY = 'FETCH_ALL_WARRANTY',
	STORE_ALL_WARRANTY = 'STORE_ALL_WARRANTY',
	ERROR_FETCH_ALL_WARRANTY = 'ERROR_FETCH_ALL_WARRANTY',

	UPDATE_WARRANTY_PAYMENT = 'UPDATE_WARRANTY_PAYMENT',
	STORE_WARRANTY_PAYMENT_UPDATE = 'STORE_WARRANTY_PAYMENT_UPDATE',
	ERROR_UPDATE_WARRANTY_PAYMENT = 'ERROR_UPDATE_WARRANTY_PAYMENT',

	FETCH_CUTLIST_DATA = 'FETCH_CUTLIST_DATA',
	STORE_CUTLIST_DATA = 'STORE_CUTLIST_DATA',
	ERROR_CUTLIST_DATA = 'ERROR_CUTLIST_DATA',

	FETCH_OPTIMISER_DATA = 'FETCH_OPTIMISER_DATA',
	STORE_OPTIMISER_DATA = 'STORE_OPTIMISER_DATA',
	ERROR_OPTIMISER_DATA = 'ERROR_OPTIMISER_DATA',

	FETCH_OPTIMIZED_CUTLIST_DATA = 'FETCH_OPTIMIZED_CUTLIST_DATA',

	FETCH_ASSIGNED_PROJECTS = 'FETCH_ASSIGNED_PROJECTS',
	STORE_ASSIGNED_PROJECTS = 'STORE_ASSIGNED_PROJECTS',
	ERROR_ASSIGNED_PROJECTS = 'ERROR_ASSIGNED_PROJECTS',

	FETCH_BUILDER_STATES = 'FETCH_BUILDER_STATES',
	STORE_BUILDER_STATES = 'STORE_BUILDER_STATES',

	FETCH_PROMO_CODE_HISTORY = 'FETCH_PROMO_CODE_HISTORY',
	STORE_PROMO_CODE_HISTORY = 'STORE_PROMO_CODE_HISTORY',
	ERROR_PROMO_CODE_HISTORY = 'ERROR_PROMO_CODE_HISTORY',

	CALCULATE_PROMO_CODE_AMOUNT = 'CALCULATE_PROMO_CODE_AMOUNT',
	STORE_PROMO_CODE_AMOUNT = 'STORE_PROMO_CODE_AMOUNT',
	ERROR_PROMO_CODE_AMOUNT = 'ERROR_PROMO_CODE_AMOUNT',

	MARK_CUTLIST_VIEWED = 'MARK_CUTLIST_VIEWED',
	MARK_BOM_VIEWED = 'MARK_BOM_VIEWED',
	UPDATE_PROJECT_VIEW_FLAGS = 'UPDATE_PROJECT_VIEW_FLAGS',

	FETCH_LEAD_PROJECTS_ORDERS = 'FETCH_LEAD_PROJECTS_ORDERS',
	STORE_LEAD_PROJECTS_ORDERS = 'STORE_LEAD_PROJECTS_ORDERS',
	ERROR_LEAD_PROJECTS_ORDERS = 'ERROR_LEAD_PROJECTS_ORDERS',

	SET_USER_TIER = 'SET_USER_TIER',
	SET_STYLE_PREFERENCES = 'SET_STYLE_PREFERENCES',

	RESET_QUOTATION_DATA = 'RESET_QUOTATION_DATA'
}
